module.exports = __webpack_public_path__ + "static/media/video-polanco-noche.9bb5d61b.mp4";